<template>
  <div>
    <header class="navigation " id="navigation">
      <div class="navigation_left">
        <div class="menuIcon" id="dashboardMenu">
          <span></span>
        </div>
      </div>
      <div class="navigation_center" id="logo">
        <router-link to="/home">
          <div class="logo">
            <img src="../../assets/fun2win/imgs/fun2win-logo.png" />
          </div>
        </router-link>
      </div>
      <div class="navigation__right">
        <div class="panelWrap">
          <Search />
          <span class="icon flaticon-bell" id="notificationIcon"></span>
        </div>
      </div>
      <div id="notification" data-att="" class="navigation__notificationWrap">
        <Notification />
      </div>
    </header>
    <nav class="siteNavMobile">
      <div class="siteNavMobile__wraper">
        <div>
            <div class="userAccount">
              <div class="userAccount__image">
                <router-link to="/profile" class="browse_link">
                  <img src="../../assets/fun2win/imgs/dummy_account.jpg" />
                  <span class="icon flaticon-pencil-edit-button"></span>
                </router-link>
              </div>
              <div class="userAccount__name">
                <p>{{$t("hello")}}, Alan Smith!</p>
              </div>
            </div>
            <ul class="navLinks">
              <li>
                <div class="translationBtns">
                  <div class="btnContainer left inline">
                    <button id="lang1" lang="english" class="mobiBtn sm ">
                      <img lang="english" src="https://i.imgur.com/oi8qUPx.png" />
                      <span lang="english">English</span>
                    </button>
                    <div v-html="langButton_f2w" id="lang2"></div>
                  </div>
                </div>
              </li>
              <li class="navLinks__item">
                <router-link to="/home" class="browse_link">
                {{ $t("home") }}
                </router-link>
              </li>
              <li class="navLinks__item " v-for="cat in $props.browse.category" :key="cat.key" @click="getclick()">
                <router-link :to="{name: 'Subcategory', params: { subcategory: cat.route }}"  class="browse_link ">
                  <span :class="cat.icon" class="icon"></span>
                  <span>{{ cat[`title_${lang_f2w}`] }}</span>
                </router-link>
              </li>
              <li class="navLinks__item sm">
                <router-link
                  style="text-decoration:none;"
                  to="/hotpicks"
                  class="browse_link text_color">
                  <span class="flaticon-flame icon"></span>
                  <span>{{ $t("hotpicks") }}</span>
                  
                  </router-link
                >
              </li>
              <li class="navLinks__item sm">
                <router-link
                  style="text-decoration:none;"
                  to="/popular"
                  class="browse_link text_color">
                  <span class="flaticon-graph icon"></span>
                  <span> {{ $t("popular") }}</span>
                
                  </router-link
                >
              </li>
              <!-- <li class="navLinks__item sm">
                <router-link
                  style="text-decoration:none;"
                  to="/popular"
                  class="browse_link text_color"
                  ><span class="flaticon-bookmark-star icon"></span
                  >{{ $t("favorites") }}</router-link
                >
              </li> -->
              <!-- <li class="navLinks__item sm" v-if="auth === ''">
                <a
                  style="text-decoration:none;"
                  class="login_btn"
                  href="/login"
                  >{{ $t("login") }}
                </a>
              </li> -->
              <li class="navLinks__item sm" v-if="authentication_f2w === 'loggedin'">
                <a
                  style="text-decoration:none;"
                  class="login_btn"
                  href="/logout"
                  @click="logout()"
                  >
                  {{ $t("unsubscribe") }}
                </a>
              </li>
            </ul>
        </div>
        <ul class="navLinks footer">
          
          <li class="navLinks__item xs">
            <router-link to="/privacy" class="browse_link text_color">
              <span class="flaticon-padlock icon"></span>
              <span> {{ $t("privacy") }}</span>
            
              </router-link>
          </li>
          <li class="navLinks__item xs">
            <router-link to="/feedback" class="browse_link text_color">
              <span class="flaticon-information-button icon"></span>
              <span>{{ $t("feedback") }}</span>
              
              </router-link>
          </li>
        </ul>
      </div>
    
      <div class="closeNav">
        <div class="menuIcon" id="navMobileClose">
          <span></span>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import Search from "../fun2win/Search.vue";
import Notification from "../fun2win/Notification.vue";
import { mapGetters, mapActions } from "vuex";
import gsap, { TimelineLite, Linear } from "gsap";
export default {
  data() {
    return {};
  },
  props: ["browse"],
  components: {
    Search,
    Notification
  },
  computed: mapGetters([
    "langButton_f2w",
    "lang_f2w",
    "authentication_f2w",
    "country_f2w"
  ]),
  mounted() {
    this.fetchLanguageButton_f2w(this.country_f2w);
    const btnLang1 = document.getElementById("lang1");
    const btnLang2 = document.getElementById("lang2");

    const notificationIcon = document.getElementById("notificationIcon");
    const notificationPanel = document.getElementById("notification");

    if (this.lang_f2w == "english") {
      if (this.country_f2w != "ke") {
        btnLang2.style.display = "block";
        btnLang1.style.display = "none";
      } else {
        btnLang2.style.display = "none";
        btnLang1.style.display = "none";
      }
    } else if (this.lang_f2w != "english") {
      btnLang2.style.display = "none";
      btnLang1.style.display = "block";
    }

    // button translate
    btnLang1.addEventListener("click", e => {
      let lang = e.target.getAttribute("lang");
      this.$i18n.locale = "english";
      this.fetchLanguage_f2w(lang);
      localStorage.setItem("lang_f2w", lang);
      btnLang2.style.display = "block";
      btnLang1.style.display = "none";
      document.getElementsByTagName("html")[0].classList.remove("ar_layout");
    });

    btnLang2.addEventListener("click", e => {
      let lang = e.target.getAttribute("lang");
      this.$i18n.locale = lang;
      this.fetchLanguage_f2w(lang);
      localStorage.setItem("lang_f2w", lang);
      btnLang2.style.display = "none";
      btnLang1.style.display = "block";
      if (lang == "arabic") {
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
      } else {
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
      }
    });

    // notification
    notificationIcon.addEventListener("click", e => {
      notificationPanel.classList.toggle("show");
    });
    //Body listen clicks

    document.addEventListener("click", event => {
      let isClickedInside =
        notificationPanel.contains(event.target) ||
        notificationIcon.contains(event.target);

      if (!isClickedInside) {
        notificationPanel.classList.remove("show");
      }
    });
    //init menu
    this.$nextTick(() => {
      this.intiSideMenu();
      this.initTopNavScroll();
    });
  },
  methods: {
    ...mapActions(["fetchLanguage_f2w", "fetchLanguageButton_f2w"]),
    getclick() {
      // location.reload();
    },
    intiSideMenu() {
      // init mobile menu
      const mobileLinks = document.querySelectorAll(".browse_link");
      const menuIcons = document.querySelectorAll(".menuIcon");
      Object.keys(menuIcons).map(elm => {
        menuIcons[elm].addEventListener("click", () => {
          document.body.classList.toggle("mobile--active");
        });
      });

      Object.keys(mobileLinks).map(elm => {
        mobileLinks[elm].addEventListener("click", () => {
          document.body.classList.remove("mobile--active");
        });
      });
    },
    initTopNavScroll() {
      const navbar = document.getElementById("navigation");

      document
        .getElementsByTagName("html")[0]
        .addEventListener("wheel", hideOnScrollHeader);
      function hideOnScrollHeader() {
        let hasClass = document.body.classList.contains("mobile--active");

        if (event.wheelDeltaY < 0 && !hasClass) {
          navbar.classList.add("stick", "hide");
          document.body.classList.remove("mobile--active");
        } else {
          document;
          navbar.classList.remove("stick", "hide");
        }
      }
    },
    logout() {
      localStorage.removeItem("userTokenID_f2w");
      localStorage.removeItem("logged-in");
      //router.push({name: Login}).catch(err => {})
    }
  },
  watch: {
    $route(to, from) {
      // if(from.name == "Subcategory" && to.name == "Subcategory"){
      //   location.reload();
      // }
      // if (from.name == "HotPicks" && to.name == "HotPicks") {
      //   location.reload();
      // }
      // this.$router.push(`/category/game-2`)
      // react to route changes...
    }
  }
};
</script>

<style lang="css">
@import url("../../assets/fun2win/fonts/fun2win/flaticon.css");
</style>
<style lang="scss" scoped>
.gamesOnly {
  // .flaticon-3d-glasses::before {
  //   content: "\f12a";
  // }
}
.subNavLinks {
  list-style: none;
  padding: 15px 0px 15px 15px;
  .subNavLinks__item {
    margin: 15px 0;
    a {
      font-size: 1.2rem !important;
      line-height: normal;
      font-weight: 500;
      text-decoration: none;
    }
    span {
      display: inline-block;
    }
    .icon:before {
      font-size: 24px !important;
      vertical-align: middle;
      font-weight: normal;
    }
  }
}
.navigation__notificationWrap {
  display: none;
  position: absolute;
  right: 15px;
  top: 54px;
}
.navigation__notificationWrap.show {
  display: block;
}
#search {
  display: none;
}

.navigation {
  height: 77px;
  padding: 0 15px;
  position: fixed;
  width: 100%;
  top: 0px;
  z-index: 99;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: transform 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
  background: #151515;
  .icon::before {
    color: #fff;
    cursor: pointer;
  }
}

.navigation.stick {
  transform: translateY(-78px);
}
.logo {
  width: 160px;
  img {
    width: 100%;
  }
}
.menuIcon {
  border: 0;
  background: transparent;
  position: relative;
  width: 34px;
  height: 30px;
  cursor: pointer;
  outline: none;
  margin-left: 0;

  &:before {
    top: 5px;
  }
  &:after {
    top: 23px;
  }
  &:before,
  &:after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    width: 34px;
    height: 2px;
    background-color: #fff;
    transition-property: color, opacity, -webkit-transform;
    -webkit-transition-property: color, opacity, -webkit-transform;
    transition-property: transform, color, opacity;
    transition-property: transform, color, opacity, -webkit-transform;
    -webkit-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -webkit-transition-timing-function: ease-in-out;
    transition-timing-function: ease-in-out;
    -webkit-transform-origin: center;
    transform-origin: center;
  }
}
.menuIcon > span {
  display: block;
  width: 100%;
  height: 100%;
  overflow: hidden;
  text-align: left;
  text-indent: 100%;
  white-space: nowrap;
  cursor: pointer;
  &:before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    width: 34px;
    height: 2px;
    background-color: #fff;
    transition-property: color, opacity, -webkit-transform;
    -webkit-transition-property: color, opacity, -webkit-transform;
    transition-property: transform, color, opacity;
    transition-property: transform, color, opacity, -webkit-transform;
    -webkit-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -webkit-transition-timing-function: ease-in-out;
    transition-timing-function: ease-in-out;
    -webkit-transform-origin: center;
    transform-origin: center;
    top: 14px;
  }
}
.siteNavMobile {
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 240px;

  background: #fdad02;
  transform: translateX(-240px);
  transition: transform 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
  box-shadow: 0 0 14px 6px rgba(0, 0, 0, 0.3);
  .siteNavMobile__wraper {
    display: flex;
    flex-direction: column;

    padding: 2rem 0;
    justify-content: space-between;
    overflow-y: auto;
    width: 100%;
    height: 100%;
  }
  .closeNav {
    position: absolute;
    right: 0px;
    width: 82px;
    text-align: right;
    top: 21px;
    border-radius: 19px;
    background-color: #fdad02;
  }
  .menuIcon {
    margin: 0;
    display: inline-block;
    vertical-align: middle;
  }
  .menuIcon:before,
  .menuIcon:after {
    background-color: #151515;
    height: 3px;
    width: 21px;
  }
}
.mobile--active .closeNav {
  right: -35px;
}
.navLinks {
  list-style: none;
  padding: 15px;
  margin: 15px 0px 0px;
  border-top: 1px solid #da9500;
  .navLinks__item {
    margin: 20px 0px;
    a {
      display: block;
      color: #151515;
      font-size: 1.2rem;
      font-weight: 500;
      text-decoration: none;
    }
    span {
      display: inline-block;
      vertical-align: middle;
      &:before {
        color: #151515;
        font-size: 21px;
        padding-right: 0px;
        margin: 0;
        font-weight: 400;
      }
    }
  }
  .navLinks__item.sm {
    a {
      font-size: 1.2rem;
      &:hover {
        text-decoration: none;
      }
      &:before {
        font-size: 24px !important;
      }
    }
  }
  .navLinks__item.xs {
    a {
      font-size: 1rem;
      text-decoration: none;
      &:before {
        font-size: 21px !important;
      }
    }
  }
}
.navLinks.footer {
  border-top: 1px solid #da9500;
}

// .mobile--active .navigation {

//   width: 100%;
// }
.mobile--active .siteNavMobile {
  -webkit-transform: translateX(0);
  -ms-transform: translateX(0);
  transform: translateX(0);
}
.mobile--active .menuIcon::before {
  color: #fff;
  -webkit-transform: translateY(9px) rotate(135deg);
  -ms-transform: translateY(9px) rotate(135deg);
  transform: translateY(9px) rotate(135deg);
}
.mobile--active .menuIcon::after {
  color: #fff;
  -webkit-transform: translateY(-9px) rotate(45deg);
  -ms-transform: translateY(-9px) rotate(45deg);
  transform: translateY(-9px) rotate(45deg);
}
.mobile--active .menuIcon > span::before {
  opacity: 0;
  -webkit-transition-duration: 0.1s;
  -o-transition-duration: 0.1s;
  transition-duration: 0.1s;
}
.userAccount {
  text-align: center;
  position: relative;
  padding: 0 15px;
}
.userAccount__image {
  position: relative;
  width: 92px;
  height: 92px;
  border-radius: 50%;
  img {
    width: 100%;
    border-radius: 50%;
  }
  .icon {
    position: absolute;
    background-color: #fff;
    width: 28px;
    border-radius: 50%;
    height: 28px;
    line-height: 28px;
    bottom: 0;
    right: 0;
    &:before {
      margin: 0;
      color: #151515;
      font-size: 16px !important;
    }
  }
}
.userAccount__name {
  margin-top: 25px;
  text-align: left;
  p {
    margin: 0;
    font-weight: 500;
    color: #000;
    font-size: 1.2rem;
  }
}
.panelWrap {
  span {
    display: inline-block;
    vertical-align: middle;
  }
}

/*##### Arabic layout Styles#####*/
.ar_layout {
  .mobile--active .closeNav {
    left: -35px;
    right: auto;
    text-align: left;
  }
  .siteNavMobile {
    transform: translateX(240px);
    right: 0;
    left: auto;
  }
  .mobile--active .siteNavMobile {
    -webkit-transform: translateX(0);
    -ms-transform: translateX(0);
    transform: translateX(0);
  }
  .subNavLinks {
    .icon {
      direction: rtl;
    }
  }
  .navigation__notificationWrap {
    right: auto;
    left: 15px;
  }
  .userAccount__name {
    text-align: right;
  }
}

/*##### Responsive layout Styles#####*/
@media only screen and (max-width: 1365px) {
  .userAccount__image[data-v-555b0576] {
    width: 72px;
    height: 72px;
  }
  .navLinks .navLinks__item {
    margin: 15px 0px;
    font-size: 1rem;
  }
  .navigation {
    height: 62px;
  }
  // .navLinks .navLinks__item a {
  //   font-size: 1rem;
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/fun2win/Navigation.vue